import { useState } from 'react'
import ServiceTemplateInsert from '../../ServiceTemplatesCustomizer/ServiceTemplateInsert'
import {
  ServiceTemplateCreate,
  ServiceTemplateEdit,
} from '../../ServiceTemplatesCustomizer'
import { GetGlobalServiceInformationTemplatesNormalized } from '@messenger/types'
import { useEditorProbeLifetime } from '@/hooks/utility/useEditorProbeLifetime'

type ServiceInformationTemplatesMenuProps = {
  setShow: (show: boolean) => void
}

const ServiceInformationTemplatesMenu = ({
  setShow,
}: ServiceInformationTemplatesMenuProps) => {
  useEditorProbeLifetime('ServiceInformationTemplatesMenu')
  const [creatingTemplate, setCreatingTemplate] = useState(false)
  const [editingTemplate, setEditingTemplate] = useState(false)
  const [selectedTemplate, setSelectedTemplate] =
    useState<GetGlobalServiceInformationTemplatesNormalized | null>(null)

  const renderContent = () => {
    return creatingTemplate ? (
      <ServiceTemplateCreate setCreatingTemplate={setCreatingTemplate} />
    ) : editingTemplate ? (
      <ServiceTemplateEdit
        key={selectedTemplate?.id}
        setEditingTemplate={setEditingTemplate}
        template={selectedTemplate}
      />
    ) : (
      <ServiceTemplateInsert
        setShow={setShow}
        setCreatingTemplate={setCreatingTemplate}
        setEditingTemplate={setEditingTemplate}
        setSelectedTemplate={setSelectedTemplate}
      />
    )
  }

  return <>{renderContent()}</>
}

export default ServiceInformationTemplatesMenu
